import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/**
 * Базовый класс для опций ui-комопнента.
 * @publicApi
 */
let DxBaseUiOptions = class DxBaseUiOptions {
    /**
     * Базовый класс для опций ui-комопнента.
     * @publicApi
     */
    constructor() {
        /**
         * Идентификатор инстанса обекта опций (на случай загрузки из БД).
         * @name _id
         * @type {number}
         * @defaultValue - 0
         */
        this._id = 0;
    }
    /**
     * Возвращает id инстанса опции.
     * @return {number} - id инстанса опции.
     * @public
     */
    get id() {
        return this._id;
    }
    /**
     * Устанавливает id инстанса опции.
     * @param {number} value - значение id инстанса опции.
     * @public
     */
    set id(value) {
        this._id = value;
    }
    /**
     * Возвращает название виджета.
     * @return {string} - название виджета.
     * @public
     */
    get title() {
        return this._title;
    }
    /**
     * Устанавливает значение названия виджета.
     * @param {string} value - строка с названием виджета.
     * @public
     */
    set title(value) {
        this._title = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxBaseUiOptions.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxBaseUiOptions.prototype, "_title", void 0);
DxBaseUiOptions = tslib_1.__decorate([
    jsonObject
], DxBaseUiOptions);
export { DxBaseUiOptions };
